export default {
  selectNotFoundData: 'Aucun élément trouvé',
  tunnelHost: "https://demo-tarification.aabvie.net",
  APIKEYKKIAPAY: "129b74c01d2711eba7b7ed071ed3502f",
  SANDBOXAPIKEYKKIAPAY: "148591801d2711eb8d57cfb99f32798d",
}

